import React from 'react';

import {
    Alert as UIKITAlert,
    AlertProps as UIKITAlertProps,
} from '@vchasno/ui-kit';

type AlertType = 'warning' | 'success' | 'error' | 'info' | 'config';

export interface AlertProps extends Omit<UIKITAlertProps, 'type'> {
    theme?: AlertType;
    hideIcon?: boolean;
    className?: string;
    scrollIntoView?: boolean;
    wide?: boolean;
}

/**
 * Proxy component for `@vchasno/ui-kit` Alert
 * Use `@vchasno/ui-kit` instead
 */
const Alert: React.FC<React.PropsWithChildren<AlertProps>> = ({
    theme = 'info',
    wide = true, // за замовчуванням робимо на всю ширину так як це було в старому компоненті
    children,
    ...rest
}) => {
    return (
        <UIKITAlert type={theme} {...rest} wide={wide}>
            {children}
        </UIKITAlert>
    );
};

export default Alert;
